export default __webpack_public_path__ + "static/Card33-947ca43a20d65ed834320ad6f60ee33f.png";